import React, { useState, useEffect } from 'react';

import { useSearchParams, useNavigate } from 'react-router-dom';

import AuthService from '../../../services/AuthService';

import { saveAuthData } from '../../../helpers/authStorage';
import Loader from '../../../components/Loader';

let timer;

export default function AcceptInvitePage() {
  const [isError, setIsError] = useState(false);
  const [searchParams] = useSearchParams();

  const token = searchParams.get('token');

  const navigate = useNavigate();

  useEffect(() => {
    clearTimeout(timer);
    if (token) {
      timer = setTimeout(async () => {
        try {
          const response = await AuthService.checkInviteCode(token);
          saveAuthData({ accessToken: response });
          console.log(response);
          navigate(`/set-password?token=${token}`);
        } catch (error) {
          setIsError(true);
        }
      }, 100);
    }
  }, [navigate, token]);

  return (
    <div className="flex flex-col justify-center items-center h-[100vh]">
      {isError ? (
        <div
          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
          role="alert"
        >
          <strong className="font-bold">Error!</strong>
          {'  '}
          <span className="block sm:inline">
            The invite code might be incorrect or expired.
          </span>
        </div>
      ) : (
        <>
          <div className="w-full flex justify-center items-center mb-4">
            <Loader />
          </div>
          <p>Please wait</p>
        </>
      )}
    </div>
  );
}
